import React from "react";
import { inp, lbl } from "../shared";

// Field config: [key, label, opts]. opts: { type, rtl, area, rows, wide, testId, placeholder, list }
export const BASIC_FIELDS = [
  ["slug", "Slug", { testId: "pf-slug" }],
  ["name_en", "Name (EN)", { testId: "pf-name-en" }],
  ["name_ar", "Name (AR)", { rtl: true }],
  ["size", "Size"],
  ["concentration", "Concentration"],
  ["parfum_type", "Parfum Type"],
  ["price", "Price (AED)", { type: "float", testId: "pf-price" }],
  ["stock", "Stock", { type: "int", testId: "pf-stock" }],
  ["limited_qty", "Limited Qty", { type: "intOrNull" }],
];

export const PROFILE_FIELDS = [
  ["notes_en", "Notes EN (comma separated)", { list: true, wide: true }],
  ["notes_ar", "Notes AR (comma separated)", { list: true, wide: true, rtl: true }],
  ["olfactive_family_en", "Olfactive Family (EN)", { placeholder: "e.g. Oriental Woody" }],
  ["olfactive_family_ar", "العائلة العطرية (AR)", { rtl: true, placeholder: "مثال: شرقي خشبي" }],
  ["scent_profile_en", "Scent Profile (EN)", { wide: true, placeholder: "A short evocative line" }],
  ["scent_profile_ar", "بروفايل الرائحة (AR)", { wide: true, rtl: true, placeholder: "سطر قصير يعبّر عن الرائحة" }],
  ["ingredients_en", "Ingredients (EN) — comma separated", { area: true, rows: 2, wide: true, placeholder: "Cambodian Oud, Bulgarian Rose, Ambergris" }],
  ["ingredients_ar", "المكوّنات (AR) — مفصولة بفواصل", { area: true, rows: 2, wide: true, rtl: true, placeholder: "عود كمبودي، ورد بلغاري، عنبر" }],
  ["natural_percentage", "Natural Materials %", { type: "floatOrNull", testId: "product-natural-pct", placeholder: "e.g. 92" }],
];

export const TEXT_FIELDS = [
  ["short_en", "Short (EN)", { area: true, rows: 2, wide: true }],
  ["short_ar", "Short (AR)", { area: true, rows: 2, wide: true, rtl: true }],
  ["description_en", "Description (EN)", { area: true, rows: 3, wide: true }],
  ["description_ar", "Description (AR)", { area: true, rows: 3, wide: true, rtl: true }],
  ["perfumer_en", "Perfumer's Note (EN)", { area: true, rows: 2, wide: true }],
  ["perfumer_ar", "Perfumer's Note (AR)", { area: true, rows: 2, wide: true, rtl: true }],
  ["details_en", "Details (EN)", { wide: true }],
  ["details_ar", "Details (AR)", { wide: true, rtl: true }],
  ["shipping_en", "Shipping (EN)", { wide: true }],
  ["shipping_ar", "Shipping (AR)", { wide: true, rtl: true }],
];

const PARSE = {
  float: (v) => parseFloat(v) || 0,
  int: (v) => parseInt(v, 10) || 0,
  intOrNull: (v) => (v ? parseInt(v, 10) : null),
  floatOrNull: (v) => (v === "" ? null : parseFloat(v)),
};
const NUMERIC = new Set(Object.keys(PARSE));

const toInput = (value, o) => (o.list ? (value || []).join(", ") : value ?? "");
const fromInput = (raw, o) => {
  if (o.list) return raw.split(",").map((s) => s.trim()).filter(Boolean);
  return o.type ? PARSE[o.type](raw) : raw;
};

export const Field = ({ name, label, opts = {}, p, set }) => {
  const props = {
    value: toInput(p[name], opts),
    onChange: (e) => set(name, fromInput(e.target.value, opts)),
    className: inp, dir: opts.rtl ? "rtl" : undefined, placeholder: opts.placeholder,
    "data-testid": opts.testId || `pf-${name}`,
  };
  return (
    <div className={opts.wide ? "md:col-span-2" : undefined}>
      <label className={lbl}>{label}</label>
      {opts.area ? <textarea rows={opts.rows} {...props} />
        : <input type={NUMERIC.has(opts.type) ? "number" : "text"} step={opts.type === "float" ? "0.01" : undefined} {...props} />}
    </div>
  );
};

export const FieldList = ({ fields, p, set }) =>
  fields.map(([name, label, opts]) => <Field key={name} name={name} label={label} opts={opts} p={p} set={set} />);

export const StatusSelect = ({ value, onChange }) => (
  <div>
    <label className={lbl}>Status</label>
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid="pf-status" className={inp}>
      <option value="available">Available</option>
      <option value="limited_release">Limited Release</option>
      <option value="sold_out">Sold Out</option>
      <option value="coming_soon">Coming Soon</option>
    </select>
  </div>
);
